module.exports = __webpack_public_path__ + "static/media/npo-connect-square-flat-white.bd3ce05d.png";